import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Section, Heading } from "../components/Bits";

export default function Impressum() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
  }, [hash]);
  return (
    <Section>
      <Heading overline="Rechtliches" title="Impressum & Datenschutz" />
      <div className="prose max-w-3xl text-sm leading-relaxed space-y-6" data-testid="impressum-content">
        <div>
          <h3 className="font-display text-xl mb-2">Angaben gemäß luxemburgischem Recht</h3>
          <p>
            AdventureCouple.lu<br />
            Wildpflanzen-Projekt Luxemburg<br />
            E-Mail: natur@adventurecouple.lu
          </p>
        </div>

        <div>
          <h3 className="font-display text-xl mb-2">Haftungsausschluss</h3>
          <p>
            Sämtliche Inhalte auf dieser Website dienen ausschließlich der Information und Bildung.
            Sie ersetzen keine fachkundige Bestimmung vor Ort und keine medizinische Beratung.
            Das Sammeln und der Verzehr von Wildpflanzen erfolgt auf eigene Verantwortung.
            Bei Verdacht auf Vergiftung sofort das <b>Centre Antipoisons Luxembourg</b> unter <b>8002 5500</b> (kostenlos, 24/7)
            anrufen. Bei Bewusstlosigkeit, Krampfanfall oder Atemnot umgehend die <b>112</b> wählen.
          </p>
        </div>

        <div>
          <h3 id="datenschutz" className="font-display text-xl mb-2 scroll-mt-28">Datenschutz</h3>
          <p>
            Wir speichern personenbezogene Daten ausschließlich, wenn du dich registrierst, ein Tagebuch führst
            oder dich für eine Tour anmeldest. Eine Weitergabe an Dritte erfolgt nicht.
            Pflanzen­fotos für die KI-Erkennung werden temporär an Pl@ntNet übermittelt.
            Du kannst jederzeit die Löschung deiner Daten per E-Mail anfordern.
          </p>
        </div>

        <div>
          <h3 className="font-display text-xl mb-2">Urheberrecht</h3>
          <p>
            Inhalte und Texte unterliegen dem Urheberrecht. Bilder stammen aus dem eigenen Bestand
            oder von Unsplash (CC0).
          </p>
        </div>
      </div>
    </Section>
  );
}
